/* eslint-disable max-len */
import { StoreState } from '@deqo/foundation';
import { useDroppable } from '@dnd-kit/core';
import { AnimatePresence, Variants, motion } from 'framer-motion';
import React, { useContext, useState } from 'react';
import { Link } from 'wouter';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { FolderItem } from '../../common/FolderItem';
import { FolderModel } from '../Models';
import { TeamFolderActionMenu } from './TeamFolderActionMenu';

const nextAnimation: Variants = {
    before: {
        opacity: 0,
    },
    in: {
        opacity: 1,
        y: '0rem',
        transition: {
            duration: .2,
            ease: 'easeOut',
        }
    },
    out: {
        opacity: 0,
        scale: 0.5,
        transition: {
            duration: .2,
            ease: 'easeOut',
        }
    }
};

export type OnSelect = (folder: StoreState<FolderModel>) => void;

export const FolderListContext = React.createContext<{ baseUrl: string }>({ baseUrl: '~/' });

export const FolderListItem = React.memo<{ folder: FolderModel }>((props) => {

    const folder = useObserver(props.folder);
    const [deleted, setDeleted] = useState(false);
    const { baseUrl } = useContext(FolderListContext);

    // useAppEvent('board:patch', e => {
    //     if (e.folder.id === props.folder.id) {
    //         delete e.folder.createdAt;
    //         setBoard(s => ({ ...s, ...e.board }));
    //     }
    // });
    // useAppEvent('board:move', e => {
    //     if (e.boardId === props.folder.id) {
    //         setDeleted(true);
    //     }
    // });
    // useAppEvent('board:delete', e => {
    //     if (e.boardId === props.folder.id) {
    //         setDeleted(true);
    //     }
    // });

    const { setNodeRef, over } = useDroppable({
        id: `folder:${folder.id}`,
        data: {
            accepts: ['board'],
        },
    });

    const dropping = over?.id === `folder:${folder.id}`;

    return <AnimatePresence>
        {!deleted &&
            <motion.div variants={nextAnimation} initial="before" animate="in" exit="out">
                <FolderItem ref={setNodeRef} clickable dropping={dropping}>
                    <FolderItem.ActionMenu>
                        <TeamFolderActionMenu folder={folder} />
                    </FolderItem.ActionMenu>
                    <Link to={`${baseUrl}/${folder.id}`}>
                        <FolderItem.Main>
                            <FolderItem.Header>
                                <Icon src="deqo://icons/dash/folder-item" />
                            </FolderItem.Header>
                            <FolderItem.Label title={folder.label}>
                                {folder.label}
                            </FolderItem.Label>
                            <FolderItem.Description>
                                {folder.boards.length} board{folder.boards.length === 1 ? '' : 's'}
                            </FolderItem.Description>
                        </FolderItem.Main>
                    </Link>
                </FolderItem>
            </motion.div>
        }
    </AnimatePresence>;
});
